<template>
	<div class="d-flex align-center">
		<div v-if="(agps.status != additionalPaymentStatuses.APPROVED || checkApprovalChecks) && !isUserIto">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						v-if="editingPaymentStatusId !== agps.id"
						icon
						dark
						small
						color="#2D4B95"
						v-bind="attrs"
						v-on="on"
						@click.stop="startEditPaymentStatus(agps)"
					>
						<v-icon dark small>mdi-pencil-box-outline</v-icon>
					</v-btn>
					<v-btn
						v-else
						icon
						dark
						small
						color="error"
						v-bind="attrs"
						v-on="on"
						@click.stop="closeEditPaymentStatus()"
					>
						<v-icon dark small>mdi-close-circle</v-icon>
					</v-btn>
				</template>
				<span v-if="editingPaymentStatusId !== agps.id">Editar Estado de Pago</span>
				<span v-else>Cancelar Edición</span>
			</v-tooltip>
		</div>
		<div v-if="agps.status == additionalPaymentStatuses.APPROVED">
			<ApprovalChecks
				v-if="requiredRoles.length > 0"
				:item="agps"
				item_type="agps"
				icon_size="20"
				:roles_needed="requiredRoles"
				@onChange="reloadInfo"/>
			<v-tooltip bottom v-else>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						small
						color="grey"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon dark small>mdi-close-circle-outline</v-icon>
					</v-btn>
				</template>
				<span>Para editar un EP aprobado se deben configurar los perfiles necesarios para aprobar la edición</span>
			</v-tooltip>
		</div>
	</div>
</template>

<script>
import {additionalPaymentStatuses} from '@/helpers/constants/additional'
import ApprovalChecks from '@/components/Globals/Helpers/ApprovalChecks'

export default {
	name: 'AGPSClosure',
	components: {
		ApprovalChecks
	},
	props: {
		agps: {
			type: Object,
			required: true
		},
		isUserIto: {
			type: Boolean,
			required: false
		},
		editingPaymentStatusId: {
			type: Number,
			required: false
		}
	},
	computed: {
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },
		itemAprovalCheck() {
			return this.selectedProject.closure_config.find(config => config.item_type === 4 && config.use_advanced_closure)
		},
		requiredRoles() {
			return this.itemAprovalCheck ? this.itemAprovalCheck.advanced_closure_profiles : []
		},
		approvalChecks(){
			return this.agps.approval_checks
		},
		checkApprovalChecks(){
			if(!this.itemAprovalCheck) return false

			return this.requiredRoles.every(roleId => {
				return this.approvalChecks.some(item => item.job_type === roleId)
			})
		}
	},
	data() {
		return {
			additionalPaymentStatuses
		}
	},
	mounted() {
	},
	methods: {
		startEditPaymentStatus(agps) {
			this.$emit('startEditPaymentStatus', agps)
		},
		closeEditPaymentStatus() {
			this.$emit('closeEditPaymentStatus')
		},
		reloadInfo() {
			this.$emit('reloadInfo')
		}
	}
}
</script>

<style>

</style>